module.exports = __webpack_public_path__ + "img/Trummer Winfried.jpg";